import axios from "axios";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getDadosCompletos = async (cpf: string) => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/usuario/DadosCompletos/${cpf}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados completos do usuário:", error);
    throw error;
  }
};

export const getMeDadosCompletos = async () => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/usuario/me/dados-completos`;

  try {
    const response = await axios.get(apiUrl, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados completos do usuário logado:", error);
    throw error;
  }
};
